module.exports = __webpack_public_path__ + "img/Visa.6612f9d.svg";